import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/NURBANNODES/general";
import TODIS_FORM_INFRA from "./form/NURBANNODES/infrastructure";
import TODIS_FORM_TENT_COMP from "./form/NURBANNODES/tent_compliance";
import TODIS_FORM_ENV from "./form/GENERAL/environment";
import { TODIS_FORM_FIELD, TODIS_FORM_FIELD_YES_NO, TODIS_FORM_DSC } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_FORM_GENERAL_NURBANNODES from "./form/NURBANNODES/general";
import TODIS_FORM_ENV_FREIGHT from "./form/NIWW/environment";
import TODIS_FORM_ENV_FREIGHTTERMINAL from "./form/NIWW/environment";

const TODIS_FORM_NP = ({ errors, touched, status, setFieldValue, values }) => {

    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const infraTooltip = (
        <Tooltip id="infra-tooltip">
            Infrastructure characteristics
        </Tooltip>
    );

    const tentTooltip = (
        <Tooltip id="tent-tooltip">
            Compliance with the relevant TEN-T standards
        </Tooltip>
    );

    return (

        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="General" title={
                <OverlayTrigger placement="bottom" overlay={generalTooltip}>
                    <div>General</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL_NURBANNODES errors={errors} touched={touched} disabled={status} setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status} />
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>

            </Tab>

            <Tab eventKey="section 3" title={
                <OverlayTrigger placement="bottom" overlay={infraTooltip}>
                    <div>Infrastructure</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_INFRA errors={errors} touched={touched} disabled={status} sectionData={values.urbanNpmInfraDTO} setFieldValue={setFieldValue} values={values} />
            </Tab>

            <Tab eventKey="TENT" title={
                <OverlayTrigger placement="bottom" overlay={tentTooltip}>
                    <div>TEN-T Compliance</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_TENT_COMP errors={errors} touched={touched} disabled={status} />
                    </Row>
                </Container>
            </Tab>
            
        </Tabs>
    )
}
export default TODIS_FORM_NP;